<template>
    <div>
      <div class=" row mb-2" >
        <label class="col-sm-4 lh40 text-lr"><i
            v-if=" Data.data.c_priority==='S'"
            class="fa fa-asterisk text-danger font10 ml-1"
            aria-hidden="true"></i>{{ Data.data.c_name }}：</label>
        <div class="col-sm-7 ">
          <el-date-picker value-format="yyyy-MM-dd"
                          v-model="value" @change="$get_function(Data,value)"
                          type="date"
                          placeholder="选择日期">
          </el-date-picker>
        </div>{{ Data.data.c_unit }}
      </div>
    </div>
</template>

<script>
    export default {
        name: "dateBox",
        props: [
            'Data'
        ],
        data() {
            return {
              value: this.Data.data.c_value,

            }
        },
        created() {
        },

        methods: {

        }
    }
</script>

<style scoped>

</style>